"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AcornItemScreen = void 0;
var react_1 = __importStar(require("react"));
var morse_react_dialogs_1 = require("morse-react-dialogs");
var ScreenMode_1 = require("../types/ScreenMode");
var useFeedback_1 = require("../hooks/useFeedback");
var AcornScreen_1 = require("./AcornScreen");
var SuspenseFactoryContext_1 = require("./suspense/SuspenseFactoryContext");
function isFunction(value) {
    return typeof value == 'function';
}
function isPromise(value) {
    return value.hasOwnProperty('resolve');
}
var AcornItemScreen = function (props) {
    var _a;
    var _b = props.mode, mode = _b === void 0 ? ScreenMode_1.ScreenMode.Screen : _b, children = props.children, allowDismiss = props.allowDismiss, onDismissed = props.onDismissed, rest = __rest(props, ["mode", "children", "allowDismiss", "onDismissed"]);
    var _c = react_1.useState([]), asyncButtons = _c[0], setAsyncButtons = _c[1];
    var suspenseContext = SuspenseFactoryContext_1.useSuspenseFactoryContext();
    var PrimaryContentSuspenseComponent = suspenseContext.getSuspenseComponent('PrimaryContent');
    var title = (_a = props.title) !== null && _a !== void 0 ? _a : '';
    var buttons = [];
    if (isFunction(props.buttons)) {
        var buttonResponse = props.buttons(props.item);
        if (isPromise(buttonResponse)) {
            buttonResponse.then(function (newAsyncButtons) {
                setAsyncButtons(newAsyncButtons);
            });
            buttons = asyncButtons;
        }
        else {
            buttons = buttonResponse;
        }
    }
    else {
        buttons = props.buttons;
    }
    var feedbackContext = useFeedback_1.useFeedback();
    var inPageErrors = feedbackContext.getFeedbackElements(useFeedback_1.CommonFeedbackPlacement.InPage);
    return (react_1.default.createElement(react_1.default.Fragment, null, mode === ScreenMode_1.ScreenMode.Dialog ? (react_1.default.createElement(morse_react_dialogs_1.Dialog, __assign({ title: title, buttons: buttons, allowDismiss: allowDismiss, onDismissed: onDismissed }, rest),
        inPageErrors,
        children)) : (react_1.default.createElement(AcornScreen_1.AcornScreen, __assign({ title: title }, props),
        react_1.default.createElement("div", { className: "l-edit__content" },
            !props.itemFetchingState.fetching &&
                !props.itemFetchingState.fetched &&
                !props.itemFetchingState.item ? (react_1.default.createElement(react_1.default.Fragment, null, children)) : (react_1.default.createElement(PrimaryContentSuspenseComponent, { itemFetchingStatus: props.itemFetchingState }, children)),
            react_1.default.createElement("div", { className: 'l-edit__actions c-button-group' }, buttons))))));
};
exports.AcornItemScreen = AcornItemScreen;
//# sourceMappingURL=AcornItemScreen.js.map